import React from 'react';

const DashboardLoader = React.lazy(() => import('./DashboardContainer'));

export default (props) => <DashboardLoader {...props} />;
